import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78a22f3b&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=78a22f3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b66c2628a85b517bb8b270c746a8724b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a22f3b",
  null
  
)

export default component.exports